"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BRICKS = void 0;

var _bricksParagraph = require("@titelmedia/bricks-paragraph");

var _bricksSectionSimple = require("@titelmedia/bricks-section-simple");

var _bricksGallery = require("@titelmedia/bricks-gallery");

var _bricksHeadline = require("@titelmedia/bricks-headline");

var _bricksQuote = require("@titelmedia/bricks-quote");

var _bricksCta = require("@titelmedia/bricks-cta");

var _bricksImages = require("@titelmedia/bricks-images");

var _bricksVideo = require("@titelmedia/bricks-video");

var _bricksInterview = require("@titelmedia/bricks-interview");

var _bricksSeparator = require("@titelmedia/bricks-separator");

var _bricksCredits = require("@titelmedia/bricks-credits");

var _bricksMarquee = require("@titelmedia/bricks-marquee");

var _bricksElevated = require("@titelmedia/bricks-elevated");

var _bricksShoppingCarousel = require("@titelmedia/bricks-shopping-carousel");

var _bricksAgeGate = require("@titelmedia/bricks-age-gate");

var _bricksHero = require("@titelmedia/bricks-hero");

var BRICKS = {
  elements: {
    Paragraph: _bricksParagraph.Paragraph,
    Gallery: _bricksGallery.Gallery,
    Headline: _bricksHeadline.Headline,
    Quote: _bricksQuote.Quote,
    Separator: _bricksSeparator.Separator,
    Images: _bricksImages.Images,
    Video: _bricksVideo.Video,
    Interview: _bricksInterview.Interview,
    Credits: _bricksCredits.Credits,
    Marquee: _bricksMarquee.Marquee,
    Elevated: _bricksElevated.Elevated,
    ShoppingCarousel: _bricksShoppingCarousel.ShoppingCarousel,
    CTA: _bricksCta.CTA,
    AgeGate: _bricksAgeGate.AgeGate,
    Hero: _bricksHero.Hero
  },
  sections: {
    Simple: _bricksSectionSimple.Simple
  }
};
exports.BRICKS = BRICKS;